<template>
  <span variant="advance" class="ml-1">
    <b-badge varient="advance"> M </b-badge>
  </span>
</template>

<script>
  export default {
    name: 'MaterialityBadge',
    components: {},
    data() {
      return {
        show_this: false,
      };
    },
    props: {
    },
    computed: {
    },
    methods: {
    },
    created() {
    },
  };
</script>
